<template>
  <el-tabs
      :value="activeTab || 'adGroup'"
      class="ad-tabs">
    <el-tab-pane name="adGroup" lazy>
      <template #label>广告组</template>
      <app-sd-ad-group
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :campaign="proxyCampaign"
          table-name="sdAdCampaignGroup"
      ></app-sd-ad-group>
    </el-tab-pane>
    <el-tab-pane name="adProduct" lazy>
      <template #label>广告</template>
      <app-sd-ad-product
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :campaign="proxyCampaign"
          table-name="sdAdProduct"
      ></app-sd-ad-product>
    </el-tab-pane>
    <el-tab-pane name="adProductTarget" lazy>
      <template #label>商品投放</template>
      <app-sd-ad-product-target
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :campaign="proxyCampaign"
          table-name="sdAdProductTarget"
      ></app-sd-ad-product-target>
    </el-tab-pane>
    <el-tab-pane name="adNegTarget" lazy>
      <template #label>否定商品投放</template>
      <app-sd-ad-neg-target
          :init-date="initDate"
          :market-id="marketId"
          :campaign-id="campaignId"
          :campaign="proxyCampaign"
          table-name="sdAdNegTarget"
      ></app-sd-ad-neg-target>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import AppSdAdGroup from "../components/ad-group/ad-group";
  import AppSdAdProduct from "../components/ad-product/ad-product";
  import AppSdAdNegTarget from "../components/ad-neg-target/ad-neg-target";
  import AppSdAdProductTarget from "../components/ad-product-target/ad-product-target";
  import {getSdAdCampaignList} from "../../../../../api/ad";
  import {AdCampaignEnum} from "../../common/enum";
  import {inCampaignMixin, initDateMixin, inMarketMixin} from "../../common/mixin";
  
  export default {
    name: "app-sd-ad-campaign-manager",
    components: {AppSdAdGroup, AppSdAdProduct, AppSdAdNegTarget, AppSdAdProductTarget},
    mixins: [inMarketMixin, inCampaignMixin, initDateMixin],
    props: {
      activeTab: {
        default: 'adGroup',
      }
    },
    created() {
    
    },
    data() {
      return {
        AdCampaignEnum: AdCampaignEnum,
        proxyCampaign: {}
      }
    },
    methods: {
      campaignChange(campaignId) {
        getSdAdCampaignList({
          marketId: this.marketId,
          campaignId,
        })
          .then((data) => {
            this.proxyCampaign = data[0];
          })
          .complete(() => {});
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../common/common.scss';
  .ad-tabs{
    height: 100%;
    display: flex;
    flex-direction: column;
    /deep/ .el-tabs__content{
      flex: 1;
    }
    /deep/ .el-tab-pane{
      height: 100%;
    }
  }
</style>
